import { useState } from "react";
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { cmSangPx, layKichThuocQrMacDinhCm, luuKichThuocQrMacDinhCm } from "lib/caiDat";
import { taoAnhQrKemMa } from "lib/qrAnh";

const KICH_THUOC_TOI_THIEU_CM = 1;

// Nút tải QR về máy dạng PNG. Kích thước nhập theo cm (kích thước thật khi in
// dán lên vườn/sọt), quy đổi sang px theo chuẩn in 300dpi. Mặc định lấy từ
// Cài đặt nhưng sửa được ngay tại chỗ cho lần tải này (sửa xong cũng thành
// mặc định mới).
function TaiXuongQr({ value, tenFile }) {
  const [kichThuocCm, setKichThuocCm] = useState(layKichThuocQrMacDinhCm);
  const [dangTao, setDangTao] = useState(false);

  const px = cmSangPx(kichThuocCm || KICH_THUOC_TOI_THIEU_CM);

  async function taiXuong() {
    setDangTao(true);
    try {
      luuKichThuocQrMacDinhCm(kichThuocCm);
      const dataUrl = await taoAnhQrKemMa(value, px);
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = `${tenFile}.png`;
      a.click();
    } finally {
      setDangTao(false);
    }
  }

  return (
    <MDBox mt={1.5} display="flex" flexDirection="column" alignItems="center" gap={0.75}>
      <MDBox display="flex" alignItems="flex-end" gap={1}>
        <MDBox width="9rem">
          <MDInput
            type="number"
            label="Kích thước (cm)"
            value={kichThuocCm}
            onChange={(e) => setKichThuocCm(e.target.value)}
            inputProps={{ min: 1, max: 20, step: 0.5 }}
            fullWidth
          />
        </MDBox>
        <MDButton
          variant="outlined"
          color="dark"
          size="small"
          onClick={taiXuong}
          disabled={dangTao}
        >
          {dangTao ? "Đang tạo..." : "Tải xuống PNG"}
        </MDButton>
      </MDBox>
      <MDTypography variant="caption" color="text">
        Khi in ra sẽ có kích thước {kichThuocCm || 0} × {kichThuocCm || 0} cm (ảnh {px} × {px} px)
      </MDTypography>
    </MDBox>
  );
}

TaiXuongQr.propTypes = {
  value: PropTypes.string.isRequired,
  tenFile: PropTypes.string.isRequired,
};

export default TaiXuongQr;
